import { Link, Typography } from "@mui/material";
import React from "react";
import { AppBar, Box } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import DropDownMenu from "./DropDownMenu";
import { useState } from "react";
export default function DeliveryTo({setsubDetails, subDetails}) {

  const [value, setvalue] = useState("")
  const handleDelTo = (e) => {
    setvalue(e.target.value)
    setsubDetails({...subDetails, deliveryAddress:value  })
  }

  return (
    <>
      <Box>
        <Box>
          <Typography sx={{ fontSize: "20px", fontWeight: "600", pb: "8px" }}>
            Delivery To
          </Typography>
        </Box>
        <Box>
          <Box>
            <Input
            //   fullWidth
              disableUnderline="true"
              // placeholder="George Street, St."
              value={subDetails.deliveryAddress}
              defaultValue="George Street, St."
              onChange={handleDelTo}
              color="#1A1824"
              endAdornment={
                <InputAdornment position="start">
                  {/* <CalendarMonthIcon sx={{ color: "#9EA3AE" }} /> */}
                  <Link component="button">
                    <Typography>Change</Typography>
                  </Link>
                </InputAdornment>
              }
              sx={{
                borderColor: "#E1E1E6",
                border: "1px solid",
                  // width: {
                  //   xl: "698px",
                  //   lg: "100%",
                  //   md: "400px",
                  //   sm: "45%",
                  //   xs: "45%",
                  // },
                  width: "100%",
                height: {
                  lg: "56px",
                  md: "56px",
                  // sm: "45%",
                  xs: "40px",
                },
                borderRadius: "4px",
                padding: "15px, 24px, 15px, 24px",
                gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
                backgroundColor: "#F6F6F6",
                //   color: "#9EA3AE",
                paddingLeft: "27.12px",
              }}
            ></Input>
          </Box>
        </Box>

        <Box mt="10px" sx={{display: "flex", width: "100%", pb: "10px" }}>
            <img src="./images/snazzy-image 1.svg" alt="" width="100%" />
        </Box>

        <Box>
            <Typography display="inline"  sx={{ fontSize: "20px", fontWeight: "600",  }}>Delivery Instruction </Typography>
            <Typography display="inline"  sx={{ fontSize: "20px", fontWeight: "400", pb: "8px", color: "#9EA3AE" }}>(Optional)</Typography>
        </Box>

        <Box pt="10px"><DropDownMenu/></Box>
      </Box>
    </>
  );
}
